import { i18n } from '../i18n';
import { ICashCouponInfo } from '../type';
import { isAvaliable, isDayLimit, isMonthUserLimit, isTotalLimit, isTotalUserLimit } from './ui-formatter';

/** 获取基础coupon组件底部右侧的提示文案，tipsTextRight 文案 */
export const getTipsTextRightV2 = (coupon: ICashCouponInfo) => {
  const { exchangeState } = coupon;
  let tipsTextRight = '';
  if (isAvaliable(exchangeState) && coupon.availablePercent) {
    tipsTextRight = coupon.availablePercentText || i18n('剩餘x%', { availablePercent: coupon.availablePercent });
  }
  if (isDayLimit(exchangeState)) {
    tipsTextRight = coupon.dayLimitText || i18n('今日已領完');
  }
  if (isTotalLimit(exchangeState)) {
    tipsTextRight = coupon.totalLimitText || i18n('已兌罄');
  }
  if (isTotalUserLimit(exchangeState)) {
    tipsTextRight = coupon.totalUserLimitText || i18n('兌換已達上限');
  }
  if (isMonthUserLimit(exchangeState)) {
    tipsTextRight = coupon.monthUserLimitTex || i18n('兌換達月上限');
  }

  return tipsTextRight;
};
